import {
  Directive,
  HostListener,
  ElementRef,
  OnInit,
  Output,
  EventEmitter,
} from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
    selector: '[prCapitalize]',
    standalone: false
})
export class EaCapitalizeDirective implements OnInit {
  private el: HTMLInputElement;

  constructor(
    private elementRef: ElementRef,
    private control: NgControl,
  ) {
    this.el = this.elementRef.nativeElement;
  }

  ngOnInit() {}

  @HostListener('change', ['$event.target.value'])
  onChange(value) {
    let newVal = value[0].toUpperCase().concat(value.slice(1));
    this.el.value = newVal;
    this.control.control.setValue(newVal);
  }
}
